import React, { PropTypes, Component } from 'react'
import styles from './styles'
import AutoComplete from 'components/autocomplete'
import misc from 'utils/misc'

class OvertimeInput extends Component {

  static propTypes = {
    segment: PropTypes.object,
    onStartTimeSelected: PropTypes.func,
    onEndTimeSelected: PropTypes.func,
    onFocusNext: PropTypes.func,
  };

  static defaultProps = {
    segment: {},
  };

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const { start, end } = this.props.segment

    const items = []
    for (let i = 0; i < 48; i++) {
      items.push(misc.getTimeStr(i))
    }

    const startText = start === 0 || start > 0 ? misc.getTimeStr(start) : ''
    const endText = end === 0 || end > 0 ? misc.getTimeStr(end) : ''

    return (
      <div className={styles.overtimeInput}>
        <AutoComplete
          ref="start"
          placeholder="00:00"
          items={items}
          narrow
          textCenter
          value={startText}
          onSelect={this.props.onStartTimeSelected}
          onFocusNext={this.props.onFocusNext}
        />
        <span> ～ </span>
        <AutoComplete
          ref="end"
          placeholder="00:00"
          items={items}
          narrow
          textCenter
          value={endText}
          onSelect={this.props.onEndTimeSelected}
          onFocusNext={this.props.onFocusNext}
        />
      </div>
    )
  }
}

export default OvertimeInput



// WEBPACK FOOTER //
// ./src/app/components/timesheet/cell/overtimeInput.jsx